import { render } from "./NewPaymentMethod.vue?vue&type=template&id=76464621"
import script from "./NewPaymentMethod.vue?vue&type=script&lang=js"
export * from "./NewPaymentMethod.vue?vue&type=script&lang=js"
script.render = render

export default script